<template>
  <v-container
    id="lista-usuario-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-card
      class="mx-auto"
      outlined
    >
      <v-list-item three-line>
        <v-list-item-content
          id="listItemListaUsuario"
          class="pr-10"
          :style="dynamicPaddingListaUsuario"
        >
          <div class="text-overline mb-4 highlighted-item">
            Lista de Usuário
          </div>
        </v-list-item-content>
      </v-list-item>
      <v-card-actions>
        <v-row>
          <v-col
            cols="12"
            lg="12"
          >
            <v-container>
              <v-row>
                <v-col
                  id="buscaUsuario"
                  cols="12"
                  sm="4"
                  md="4"
                  lg="4"
                >
                  <tex-field-with-validation
                    v-model="usuarioSelect"
                    label="Buscar Usuário ..."
                    @keyup.enter="filtrarUsuario()"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="1"
                  md="1"
                  lg="1"
                >
                  <v-btn
                    id="cadastrarUsuario"
                    small
                    class="v-btn--block"
                    :color="corPrimaria"
                    @click="filtrarUsuario()"
                  >
                    Buscar
                  </v-btn>
                </v-col>
                <v-col
                  cols="3"
                  lg="1"
                >
                  <v-btn
                    id="cadastrarUsuario"
                    small
                    class="v-btn--block"
                    :color="corPrimaria"
                    @click="cadastrarUsuario()"
                  >
                    <v-icon>
                      mdi-plus
                    </v-icon>
                    Novo
                  </v-btn>
                </v-col>
                <v-col
                  cols="3"
                  lg="1"
                >
                  <v-btn
                    id="cadastrarUsuario"
                    small
                    class="v-btn--block"
                    :color="corPrimaria"
                    @click="showModal()"
                  >
                    <v-icon>
                      mdi-book-account-outline
                    </v-icon>
                    Tutorial Cadastro Usuário
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <div
              v-if="usuarioGet"
              id="permissionIten"
              class="col-12"
            >
              <v-row>
                <v-col
                  cols="12"
                  lg="12"
                >
                  <div class="col-12">
                    <div>
                      <div
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;"
                                class="black--text title"
                              >
                                Nome
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;"
                                class="black--text title"
                              >
                                Email
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;"
                                class="black--text title"
                              >
                                Editar
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;"
                                class="black--text title"
                              >
                                Status
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in (usuariosFiltro.length > 0 ? usuariosFiltro : usuarios)"
                              :key="item.id"
                            >
                              <td
                                id="dadoMovimentacaoListaUsuario"
                                style="text-align: left;"
                              >
                                {{ item.nome }}
                              </td>
                              <td
                                id="dadoMovimentacaoListaUsuario"
                                style="text-align: left;"
                              >
                                {{ item.username }}
                              </td>
                              <td
                                id="dadoMovimentacaoListaUsuario"
                                style="text-align: center;"
                              >
                                <v-icon
                                  class="text-h2"
                                  :color="corPrimaria"
                                  @click="atualizarUsuario(item)"
                                >
                                  mdi-pencil
                                </v-icon>
                              </td>
                              <td
                                class="text-center"
                                style="text-align: center;"
                              >
                                <custom-switch-button
                                  :initial-status="item.ativo"
                                  :item="item"
                                  @changeStatus="alterarStatus"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div
              v-else
            >
              <h3 class="text-center">
                Não há Usuários cadastrados.
              </h3>
              <div
                class="text-center"
              >
                <span>
                  <router-link
                    to="/usuarios/cadastro-usuario"
                  >Retorne para cadastrar usuários</router-link>
                </span>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <br>
    <v-dialog
      v-model="dialog.visible"
      transition="dialog-bottom-transition"
      persistent
      max-width="700px"
      @keydown.esc="dialog.visible = false"
    >
      <v-card>
        <v-card-title>
          <v-spacer />
          <v-icon
            aria-label="Close"
            @click="dialog.visible = false, excluirPagina = true"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="text-center">
          <h4>{{ dialog.message }}</h4>
        </v-card-text>
        <v-card-text class="pb-3 pt-6 text-center">
          <v-container>
            <div id="video">
              <youtube-embed
                id="youtube"
                :video-id="'bFmsEjVZg6k'"
              />
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      id="dialogFiltros"
      v-model="dialogCadastroUsuario.visible"
      transition="dialog-bottom-transition"
      max-width="85%"
      persistent
      content-class="custom-dialog-content"
      @keydown.esc="dialogCadastroUsuario.visible = false, usuario.email = '', usuario.password = '', usuario.nome = '', usuario.exibirPassword = true, usuarioCadastro = false, tab = 0, showUsuarios()"
    >
      <v-card
        height="100%"
        class="dialog-card-fill"
      >
        <v-card-title>
          <v-spacer />
          <h2>{{ dialogCadastroUsuario.message }}</h2>
          <v-icon
            aria-label="Close"
            @click="dialogCadastroUsuario.visible = false, usuario.email = '', usuario.password = '', usuario.nome = '', usuario.exibirPassword = true, usuarioCadastro = false, tab = 0, showUsuarios()"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="text-center dialog-body-scroll">
          <v-row class="text-center">
            <v-col
              cols="12"
              md="12"
            >
              <v-row>
                <v-col
                  cols="4"
                  md="4"
                >
                  <tex-field-with-validation
                    :value="usuario.nome"
                    rules="required|regex:^([a-zA-Z0-9-_]+([a-zA-Z0-9-_ ])+)$"
                    type="text"
                    label="Nome..."
                    prepend-icon="mdi-account-box-outline"
                    @input="(value) => { usuario.nome = value }"
                  />
                </v-col>
                <v-col
                  cols="4"
                  md="4"
                >
                  <tex-field-with-validation
                    :value="usuario.email"
                    rules="email"
                    required
                    type="email"
                    label="Email ..."
                    prepend-icon="mdi-email-fast"
                    @input="(value) => { usuario.email = value }"
                  />
                </v-col>
                <v-col
                  v-if="usuario.exibirPassword"
                  cols="4"
                  md="4"
                >
                  <tex-field-with-validation
                    :value="usuario.password"
                    required
                    :type="inputType ? 'text' : 'password'"
                    label="Senha"
                    prepend-icon="mdi-lock"
                    :append-icon="inputType ? 'mdi-eye' : 'mdi-eye-off'"
                    @input="(value) => { usuario.password = value }"
                    @click:append="inputType = !inputType"
                  />
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col
                  cols="4"
                  lg="2"
                >
                  <v-btn
                    v-if="usuario.nome && usuario.email && usuario.password"
                    id="btnSalvarAtualiza"
                    small
                    class="v-btn--block btn-unificado"
                    :color="corPrimaria"
                    @click="textoBotao === 'Salvar' ? salvarUsuario() : atualizarCadastroUsuario()"
                  >
                    {{ textoBotao }}
                  </v-btn>

                  <v-btn
                    v-else
                    id="btnSalvarAtualiza"
                    small
                    disabled
                    class="v-btn--block btn-unificado"
                    :color="corPrimaria"
                  >
                    {{ textoBotao }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="usuarioCadastro">
            <v-col cols="12">
              <v-card>
                <v-tabs
                  v-model="tab"
                  background-color="#2863af"
                  dark
                >
                  <v-tab>Páginas</v-tab>
                  <v-tab>Vendedores</v-tab>
                </v-tabs>
                <v-divider />
                <v-window v-model="tab">
                  <v-window-item :value="0">
                    <v-card
                      flat
                      class="pa-4"
                    >
                      <div class="d-flex justify-start">
                        <v-btn
                          id="btnShowPermissao"
                          class="text-left btn-unificado"
                          small
                          :color="corPrimaria"
                          :disabled="userMaster"
                          @click="showListaPaginas()"
                        >
                          Permissões Páginas
                        </v-btn>
                      </div>

                      <div v-if="permissions">
                        <div style="overflow-x:auto;">
                          <div
                            id="idTable"
                            style="overflow-x: auto; max-width: 100%;"
                          >
                            <table
                              style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                              class="elevation-1"
                            >
                              <thead>
                                <tr>
                                  <th
                                    class="black--text title"
                                    style="text-align:center"
                                  >
                                    Nome
                                  </th>
                                  <th
                                    class="black--text title"
                                    style="text-align:center"
                                  >
                                    Modulo
                                  </th>
                                  <th
                                    class="black--text title"
                                    style="text-align:center"
                                  >
                                    Url
                                  </th>
                                  <th
                                    class="black--text title"
                                    style="text-align:center"
                                  >
                                    Permissão
                                  </th>
                                  <th
                                    class="black--text title"
                                    style="text-align:center"
                                  >
                                    Atualizar
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                <tr
                                  v-for="item in paginasExibicao"
                                  :key="item.id"
                                >
                                  <td style="text-align:left">
                                    {{ item.nome }}
                                  </td>
                                  <td style="text-align:left">
                                    {{ item.modulo }}
                                  </td>
                                  <td style="text-align:center">
                                    {{ item.url }}
                                  </td>
                                  <td style="text-align:center">
                                    {{ item.permissao }}
                                  </td>
                                  <td style="text-align:center">
                                    <v-icon
                                      class="text-h2"
                                      :color="corPrimaria"
                                      @click="cadastrarPemissaoPagina(item), excluirPagina = true"
                                    >
                                      mdi-pencil
                                    </v-icon>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div v-else>
                        Não há permissões cadastradas para esse usuário
                      </div>
                    </v-card>
                  </v-window-item>
                  <v-window-item :value="1">
                    <v-card
                      flat
                      class="pa-4"
                    >
                      <div class="d-flex justify-start">
                        <v-btn
                          id="btnShowPermissao"
                          class="text-left btn-unificado"
                          small
                          :color="corPrimaria"
                          :disabled="userMaster"
                          @click="showListaVendedores()"
                        >
                          Visualização de Dados
                        </v-btn>
                      </div>

                      <div v-if="permissionsVendedores">
                        <div
                          id="idTable"
                          style="overflow-x: auto; max-width: 100%;"
                        >
                          <table
                            style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                            class="elevation-1"
                          >
                            <thead>
                              <tr>
                                <th
                                  class="black--text title"
                                  style="text-align:center"
                                >
                                  Nome
                                </th>
                                <th
                                  class="black--text title"
                                  style="text-align:center"
                                >
                                  Remover
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr
                                v-for="item in vendedoresExibicao"
                                :key="item.id"
                              >
                                <td style="text-align:left">
                                  {{ item.vendedor }}
                                </td>
                                <td style="text-align:center">
                                  <v-icon
                                    class="text-h2"
                                    :color="corError"
                                    @click="RemoverVendedor(item)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div v-else>
                        Permitido a exibição dos dados de todos os vendores
                      </div>
                    </v-card>
                  </v-window-item>
                </v-window>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="dialog-footer-fixed">
          <v-row justify="center">
            <v-col
              cols="4"
              lg="2"
            >
              <v-btn
                class="btn-unificado"
                small
                :color="corPrimaria"
                @click="dialogCadastroUsuario.visible = false, usuario.email = '', usuario.password = '', usuario.nome = '', usuario.exibirPassword = true, usuarioCadastro = false, tab = 0, showUsuarios()"
              >
                Fechar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      id="dialogFiltros"
      v-model="dialogPaginas.visible"
      transition="dialog-bottom-transition"
      persistent
      max-width="75%"
      content-class="custom-dialog-content-permissao"
      @keydown.esc="dialogPaginas.visible = false"
    >
      <v-card>
        <v-card-title>
          <v-spacer />
          <h2>{{ dialogPaginas.message }}</h2>
          <v-icon
            aria-label="Close"
            @click="dialogPaginas.visible = false"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-row class="text-center">
          <v-col
            cols="2"
          >
            <h3
              id="textoFiltro"
              class="text-center"
            >
              Filtros
            </h3>
          </v-col>
          <v-col
            id="filtroModulo"
            cols="4"
          >
            <v-select
              v-model="moduloSelect"
              :items="modulo"
              item-value="id"
              item-text="nome"
              label="Modulo"
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.nome }}, </span>
                </v-chip>
                <v-chip v-if="index === 1">
                  <span>{{ item.nome }}, </span>
                </v-chip>
                <v-chip v-if="index === 2">
                  <span>{{ item.nome }}, </span>
                </v-chip>
                <span
                  v-if="index === 3"
                  class="grey--text text-caption"
                >
                  (+{{ moduloSelect.length - 3 }} outros)
                </span>
              </template>
            </v-select>
          </v-col>
          <v-col
            id="filtroPagina"
            cols="4"
          >
            <tex-field-with-validation
              v-model="paginaSelect"
              label="Nome ..."
            />
          </v-col>
          <v-col
            id="filtroPagina"
            cols="2"
          >
            <v-icon
              id="iconSearch"
              :color="corPrimaria"
              @click="filterPaginas"
            >
              mdi-magnify
            </v-icon>
          </v-col>
        </v-row>
        <v-container>
          <v-row class="text-center">
            <v-col
              cols="12"
              md="12"
            >
              <div
                id="idTable"
                style="overflow-x: auto; max-width: 100%;"
              >
                <table
                  style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                  class="elevation-1"
                >
                  <thead>
                    <tr>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        class="black--text title"
                      >
                        Nome
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        class="black--text title"
                      >
                        Modulo
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        class="black--text title"
                      >
                        Url
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        class="black--text title"
                      >
                        Adicionar Permissão
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in (enablefilter ? paginasFilter : paginas)"
                      :key="item.id"
                    >
                      <td
                        id="dadoMovimentacaoListaUsuario"
                        style="text-align: left;"
                      >
                        {{ item.nome }}
                      </td>
                      <td
                        id="dadoMovimentacaoListaUsuario"
                        style="text-align: left;"
                      >
                        {{ item.modulo }}
                      </td>
                      <td
                        id="dadoMovimentacaoListaUsuario"
                        style="text-align: center;"
                      >
                        {{ item.url }}
                      </td>
                      <td
                        id="dadoMovimentacaoListaUsuario"
                        style="text-align: center;"
                      >
                        <v-icon
                          class="text-h2"
                          :color="corPrimaria"
                          @click="cadastrarPemissaoPagina(item), excluirPagina = false"
                        >
                          mdi-plus-circle-outline
                        </v-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-col>
          </v-row>
          <v-card-actions class="dialog-footer-fixed">
            <v-row justify="center">
              <v-col
                cols="4"
                lg="2"
              >
                <v-btn
                  class="btn-unificado"
                  small
                  :color="corPrimaria"
                  @click="dialogPaginas.visible = false"
                >
                  Fechar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      id="dialogFiltros"
      v-model="dialogListaVendedores.visible"
      transition="dialog-bottom-transition"
      max-width="75%"
      content-class="custom-dialog-content-permissao"
      persistent
      @keydown.esc="dialogListaVendedores.visible = false"
    >
      <v-card>
        <v-card-title>
          <v-spacer />
          <h2>{{ dialogListaVendedores.message }}</h2>
          <v-icon
            aria-label="Close"
            @click="dialogListaVendedores.visible = false"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-container>
          <v-row class="text-center">
            <v-col
              cols="12"
              md="12"
            >
              <div
                id="idTable"
                style="overflow-x: auto; max-width: 100%;"
              >
                <table
                  style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                  class="elevation-1"
                >
                  <thead>
                    <tr>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        class="black--text title"
                      >
                        Nome
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        class="black--text title"
                      >
                        Visualizar Dados
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in vendedores"
                      :key="item.id"
                    >
                      <td
                        id="dadoMovimentacaoListaUsuario"
                        style="text-align: left;"
                      >
                        {{ item.vendedor }}
                      </td>
                      <td
                        id="dadoMovimentacaoListaUsuario"
                        style="text-align: center;"
                      >
                        <v-simple-checkbox
                          v-model="item.visualizarDados"
                          :ripple="false"
                          color="green"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-col>
          </v-row>
          <v-card-actions class="dialog-footer-fixed">
            <v-row justify="center">
              <v-col
                cols="4"
                lg="2"
              >
                <v-btn
                  class="btn-unificado"
                  small
                  :color="corPrimaria"
                  @click="dialogListaVendedores.visible = false"
                >
                  Fechar
                </v-btn>
              </v-col>
              <v-col
                cols="4"
                lg="2"
              >
                <v-btn
                  class="btn-unificado"
                  small
                  :color="corPrimaria"
                  @click="permitirVisualizarDados(), dialogListaVendedores.visible = false"
                >
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPermissaoPagina.visible"
      transition="dialog-bottom-transition"
      persistent
      max-width="45%"
      @keydown.esc="dialogPermissaoPagina.visible = false"
    >
      <v-card>
        <v-card-title>
          <v-spacer />
          <h4>{{ dialogPermissaoPagina.message }}</h4>
          <v-icon
            aria-label="Close"
            @click="dialogPermissaoPagina.visible = false, excluirPagina = true"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="pb-3 pt-6 text-center">
          <v-container>
            <v-row class="text-center">
              <v-col
                cols="12"
                md="12"
              >
                <v-row>
                  <v-col
                    cols="6"
                    md="6"
                  >
                    <v-text-field
                      v-model="pagina.modulo"
                      type="text"
                      label="Modulo..."
                      disabled
                    />
                  </v-col>
                  <v-col
                    cols="6"
                    md="6"
                  >
                    <v-text-field
                      v-model="pagina.menuModulo"
                      type="text"
                      label="Nome do link ..."
                      disabled
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="6"
                    md="6"
                  >
                    <v-text-field
                      v-model="pagina.url"
                      type="text"
                      label="Url do item"
                      disabled
                    />
                  </v-col>
                  <v-col
                    cols="6"
                    md="6"
                  >
                    <v-select
                      v-if="!selected"
                      v-model="selectPermissao"
                      :items="type"
                      item-value="id"
                      item-text="nome"
                      label="Tipo de Permissão"
                      return-object
                    />
                    <v-select
                      v-else
                      v-model="selectPermissao"
                      :items="type"
                      item-value="id"
                      item-text="nome"
                      label="Tipo de Permissão"
                      return-object
                    />
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col
                    v-if="excluirPagina"
                    cols="4"
                    lg="2"
                  >
                    <v-btn
                      small
                      class="v-btn--block btn-unificado-salvar-excluir"
                      :color="corPrimaria"
                      @click="excluirPermissao(pagina), dialogPermissaoPagina.visible = false, excluirPagina = true"
                    >
                      Excluir
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="4"
                    lg="2"
                  >
                    <v-btn
                      id="logar"
                      small
                      class="v-btn--block btn-unificado-salvar-excluir"
                      :color="corPrimaria"
                      @click="salvarPermissao(), dialogPermissaoPagina.visible = false, excluirPagina = true"
                    >
                      Salvar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    >
      {{ snackbar.message }}
    </dashboard-core-snackbar>
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Menu from '../../../../services/menu'
  import Usuario from '../../../../services/usuario'
  import YoutubeEmbed from '../../../../components/base/YoutubeEmbed'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'PageListaUsuarios',
    emits: ['enablePermissao', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      YoutubeEmbed,
      CustomSwitchButton: () => import('../../components/core/CustomSwitchButton'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      styleObjectError: {
        color: localStorage.corError,
      },
      corError: localStorage.corError,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectMeta: {
        color: '#ed934f',
      },
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      usuarios: [],
      usuarioGet: false,
      headers: [
        { text: 'Nome', value: 'nome', width: '30%', class: 'black--text title' },
        { text: 'Email', value: 'username', width: '40%', align: 'center', class: 'black--text title' },
        { text: 'Status ', value: 'ativo', width: '15%', align: 'center', class: 'black--text title' },
        { text: 'Editar ', value: 'editarUsuario', width: '15%', align: 'center', class: 'black--text title' },
      ],
      user: [],
      paginaEnable: false,
      dialog: {
        visible: false,
        message: '',
      },
      dialogCadastroUsuario: {
        visible: false,
        message: '',
      },
      maxWidth: window.innerWidth,
      usuario: {
        email: '',
        password: '',
        nome: '',
        exibirPassword: true,
      },
      emailRules: [
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail é obrigatório',
      ],
      nomeRules: [
        v => /^[a-zA-Z0-9-_]+([a-zA-Z0-9-_ ])+$/.test(v) || 'Nome é obrigatório e não pode conter apenas espaços e caracteres especiais',
      ],
      inputType: false,
      permissions: false,
      permissionsVendedores: false,
      paginasExibicao: [],
      vendedores: [],
      vendedoresExibicao: [],
      tab: 0,
      userMaster: false,
      dialogPaginas: {
        visible: false,
        message: '',
      },
      dialogPermissaoPagina: {
        visible: false,
        message: '',
      },
      dialogListaVendedores: {
        visible: false,
        message: '',
      },
      pagina: {
        id: '',
        modulo: '',
        menuModulo: '',
        moduloId: '',
        url: '',
        visible: '',
      },
      paginas: [],
      paginaFiltro: [],
      paginaSelect: '',
      paginasFilter: [],
      modulo: [],
      moduloSelect: [],
      enablefilter: false,
      selected: false,
      selectPermissao: '',
      excluirPagina: false,
      type: [
        { id: 1, text: 'ADMINISTRADOR', nome: 'Administrador' },
        { id: 2, text: 'USUARIO', nome: 'Usuário' },
        { id: 3, text: 'MASTER', nome: 'Master' },
      ],
      usuarioCadastro: false,
      textoBotao: 'Salvar',
      dynamicPaddingListaUsuario: '',
      usuarioSelect: '',
      usuariosFiltro: [],
    }),

    beforeDestroy () {
      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Lista Usuários')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        localStorage.removeItem('userId')
        localStorage.removeItem('userUsername')

        Menu.verificarPermissaoPaginaUsuario(localStorage.username, window.location.href, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.paginaEnable = true
          } else {
            this.$router.push('/dashboard')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })

        this.usuarioIdentificado = true

        this.showUsuarios()
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingListaUsuario = 'padding-right: 115rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingListaUsuario = 'padding-right: 85rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingListaUsuario = 'padding-right: 25rem !important'
        } else if (window.innerWidth > 600 && window.innerWidth < 1000) {
          this.dynamicPaddingListaUsuario = 'padding-right: 40rem !important'
        } else {
          this.dynamicPaddingListaUsuario = 'padding-right: 78rem !important'
        }
      },

      async showUsuarios () {
        await Menu.showUsuarios(localStorage.tokencontrato).then(resposta => {
          if (resposta.data.usuarios) {
            this.usuarios = resposta.data.usuarios
            this.usuarioGet = true
          } else {
            this.usuarios = 0
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      cadastrarUsuario () {
        this.user = []

        this.textoBotao = 'Salvar'

        this.showDialogCadastroUsuario('Cadastro Usuário')
      },

      tutorialCadastrarUsuario () {
        this.$root.$emit('enable-permissao', this.paginaEnable)
        this.$router.push('/usuarios/tutorial-cadastro')
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      showModal () {
        this.showDialog('Tutorial Cadastro de Usuários')
      },

      showDialog (message) {
        this.dialog.visible = true
        this.dialog.message = message
      },

      showDialogCadastroUsuario (message) {
        this.dialogCadastroUsuario.visible = true
        this.dialogCadastroUsuario.message = message
      },

      async salvarUsuario () {
        var padraoEmail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/

        var padraoNome = /^[a-zA-Z0-9-_]+([a-zA-Z0-9-_ ])+$/

        var validaEmail = this.usuario.email.match(padraoEmail)

        var validaNome = this.usuario.nome.match(padraoNome)

        if (!validaNome || !this.usuario.nome) {
          alert('Nome é obrigatório ou está com formato inválido')
        } else if (!validaEmail || !this.usuario.email) {
          alert('Email é obrigatório ou está com formado inválido')
        } else if (this.usuario.username !== '' && this.usuario.email !== '' && this.usuario.password !== '') {
          await Usuario.saveUser(this.usuario, localStorage.tokencontrato, window.location.href).then(resposta => {
            if (!resposta.data.status) {
              this.showSnackbar('error', 5000, resposta.data.msg)
            } else if (resposta.data.status) {
              this.showSnackbar('success', 3000, resposta.data.msg)

              this.enabled = false
              this.user = resposta.data.usuario

              this.usuarioCadastro = true

              this.select = ''

              this.vendedoresExibicao = []
              this.paginasExibicao = []
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          })
        } else {
          alert('Campos Nome, Email e Senha são obrigatórios')
        }
      },

      async showPaginas () {
        await Menu.showPaginas(localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.paginas = resposta.data.paginas

            this.paginaFiltro = resposta.data.pagina

            this.modulo = resposta.data.modulo
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Páginas não encontradas') {
            this.showSnackbar('error', 3000, 'Páginas não encontradas')
          }
        })
      },

      showListaPaginas () {
        this.showPaginas()

        this.paginas = []

        this.showDialogPaginas('Lista de páginas')
      },

      showDialogPaginas (message) {
        this.dialogPaginas.visible = true
        this.dialogPaginas.message = message
      },

      filterPaginas () {
        this.enablefilter = false

        if (this.paginaSelect.length > 0 && this.moduloSelect.length > 0) {
          this.enablefilter = true

          this.paginasFilter = this.paginas.filter(item =>
            this.moduloSelect.some(modulo => item.modulo === modulo.nome) &&
            this.paginaSelect.split(',').some(paginaParte => item.nome.toLowerCase().includes(paginaParte.toLowerCase())),
          )
        } else if (this.paginaSelect.length > 0) {
          this.enablefilter = true

          this.paginasFilter = this.paginas.filter(item =>
            this.paginaSelect.split(',').some(paginaParte => item.nome.toLowerCase().includes(paginaParte.toLowerCase())),
          )
        } else if (this.moduloSelect.length > 0) {
          this.enablefilter = true

          this.paginasFilter = this.paginas.filter(item =>
            this.moduloSelect.some(pagina => item.modulo === pagina.nome),
          )
        } else {
          this.paginasFilter = []
        }
      },

      cadastrarPemissaoPagina (value) {
        this.pagina.modulo = value.modulo
        this.pagina.menuModulo = value.nome
        this.pagina.url = value.url
        this.pagina.id = value.paginaId
        this.pagina.visible = value.visible
        this.pagina.moduloId = value.moduloId

        if (value.permissao) {
          var i = 0

          for (i in this.type) {
            if (this.type[i].nome === value.permissao) {
              this.selectPermissao = this.type[i]
            }
          }
        }

        this.showDialogPermissaoPagina('Cadastrar Permissão')
      },

      showDialogPermissaoPagina (message) {
        this.dialogPermissaoPagina.visible = true
        this.dialogPermissaoPagina.message = message
      },

      async salvarPermissao () {
        await Menu.salvarPermissao(this.pagina, this.user.id, this.user.username, this.selectPermissao, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.msg === 'Permissão atualizada com sucesso') {
            this.selectPermissao = ''
            this.showSnackbar('success', 3500, resposta.data.msg)

            this.showPermissions()
          } else if (resposta.data.msg === 'Permissão cadastrada com sucesso') {
            this.selectPermissao = ''

            this.showPermissions()
            this.showSnackbar('success', 3500, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.errors === 'Usuario não encontrado') {
            this.showSnackbar('error', 3000, e.data.errors)
          } else if (e.data.errors === 'Página não encontrada') {
            this.showSnackbar('error', 3000, e.data.errors)
          } else if (e.data.errors === 'Empresa não encontrada') {
            this.showSnackbar('error', 3000, e.data.errors)
          }
        })
      },

      async showPermissions () {
        await Menu.showPermissions(this.user.id, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.permissao) {
            this.paginasExibicao = resposta.data.permissao

            this.permissions = true
          } else {
            this.paginasExibicao = false

            this.permissions = false
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      atualizarUsuario (item) {
        this.user = item

        this.usuario.nome = item.nome

        this.usuario.email = item.username

        this.usuario.password = item.password

        this.usuario.exibirPassword = false

        this.textoBotao = 'Atualizar'

        this.usuarioCadastro = true

        this.showPermissions()

        this.showVendedores()

        this.showDialogCadastroUsuario('Atualizar Usuário')
      },

      async alterarStatus (item) {
        if (item.item.ativo !== item.newStatus) {
          await Usuario.altualizarStatus(item, localStorage.tokencontrato).then(resposta => {
            if (resposta.data.status) {
              this.showSnackbar('success', 3000, 'Status do usuário alterado')

              this.showUsuarios()
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          })
        }
      },

      async showVendedores () {
        await Menu.showDadosVendedores(localStorage.tokencontrato, this.user.id).then(resposta => {
          if (resposta.data.status) {
            this.vendedores = resposta.data.vendedor

            this.vendedoresExibicao = this.vendedores
              .filter(v => v.visualizarDados === true)
              .map(v => ({
                id: v.id,
                vendedor: v.vendedor,
              }))

            this.vendedoresExibicao.length > 0 ? this.permissionsVendedores = true : this.permissionsVendedores = false
          } else if (resposta.data.msg === 'Contrato não encontrato') {
            this.showSnackbar('error', 3000, 'Contrato não encontrato')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async permitirVisualizarDados () {
        await Menu.showSalvarDadosRelacao(localStorage.tokencontrato, this.user.id, this.user.username, this.vendedores).then(resposta => {
          if (resposta.data.status) {
            this.vendedoresExibicao = this.vendedores
              .filter(v => v.visualizarDados === true)
              .map(v => ({
                id: v.id,
                vendedor: v.vendedor,
              }))

            this.vendedoresExibicao.length > 0 ? this.permissionsVendedores = true : this.permissionsVendedores = false

            this.showSnackbar('success', 3000, 'Dados salvos com sucesso')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      showListaVendedores () {
        this.vendedores = []

        this.showVendedores()

        this.showDialogListaVendedores('Lista de Vendedores')
      },

      showDialogListaVendedores (message) {
        this.dialogListaVendedores.visible = true
        this.dialogListaVendedores.message = message
      },

      async showVendedoresExibicao () {
        await Menu.showDadosVendedores(localStorage.tokencontrato, this.user.id).then(resposta => {
          if (resposta.data.status) {
            this.vendedoresExibicao = resposta.data.vendedor
              .filter(v => v.visualizarDados === true)
              .map(v => ({
                id: v.id,
                vendedor: v.vendedor,
              }))

            if (this.vendedoresExibicao.length > 0) {
              this.permissionsVendedores = true
            }
          } else if (resposta.data.msg === 'Contrato não encontrato') {
            this.showSnackbar('error', 3000, 'Contrato não encontrato')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async RemoverVendedor (vendedor) {
        await Menu.removerVendedorRelacao(localStorage.tokencontrato, this.user.id, this.user.username, vendedor).then(resposta => {
          if (resposta.data.status) {
            this.vendedoresExibicao = resposta.data.vendedor
              .filter(v => v.visualizarDados === true)
              .map(v => ({
                id: v.id,
                vendedor: v.vendedor,
              }))

            this.vendedoresExibicao.length > 0 ? this.permissionsVendedores = true : this.permissionsVendedores = false
          } else if (resposta.data.msg === 'Contrato não encontrato') {
            this.showSnackbar('error', 3000, 'Contrato não encontrato')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async excluirPermissao (pagina) {
        await Menu.excluirPermissao(this.user.username, pagina, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.showPermissions()

            this.selectPermissao = ''
            this.showSnackbar('success', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async atualizarCadastroUsuario () {
        if (this.user.nome !== '' && this.user.username !== '') {
          Usuario.atualizarUsuario(this.user, localStorage.tokencontrato, window.location.href).then(resposta => {
            if (resposta.data.status) {
              this.showSnackbar('success', 3000, resposta.data.msg)
            } else if (resposta.data.msg === 'Email informado já está cadastrado em um outro usuário, favor verificar a Lista de Usuários') {
              this.showSnackbar('success', 3000, resposta.data.msg)
              alert('Clique para verificar a Lista de Usuários', this.$router.push('/usuarios/lista-usuarios'))
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            } else if (e.data.msg === 'Usuário não encontrado') {
              this.showSnackbar('error', 3000, 'Usuário não encontrado')
            } else if (e.data.msg === 'Empresa não encontrada') {
              this.showSnackbar('error', 3000, 'Empresa não encontrada')
            }
          })
        } else if (this.user.nome === '') {
          alert('Campos nome não pode ser vazio')
        } else if (this.user.username === '') {
          alert('Campos email não pode ser vazio')
        } else {
          alert('Campos Nome, Email não podem estar vazios')
        }
      },

      filtrarUsuario () {
        if (this.usuarioSelect.length > 0) {
          this.usuariosFiltro = this.usuarios.filter(item =>
            this.usuarioSelect.split(',').some(usuarioParte => item.nome.toLowerCase().includes(usuarioParte.toLowerCase())),
          )
        } else {
          this.usuariosFiltro = []
        }
      },
    },
  }
</script>

<style scoped>
  .v-switch .switch-ativo .v-switch__thumb {
  background-color: green !important;
    border-color: green !important;
  }

  .v-switch .switch-ativo .v-switch__track {
    background-color: green !important;
    border-color: green !important;
  }

  .v-switch .switch-inativo .v-switch__thumb {
    background-color: red !important;
    border-color: red !important;
  }

  .v-switch .switch-inativo .v-switch__track {
    background-color: red !important;
    border-color: red !important;
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 410px !important;
    }

    #dadoMovimentacaoListaUsuario {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }
</style>

<style lang="sass">
  #ul_product
    list-style-type: none
    margin-left: -3rem

  .custom-dialog-content
    height: 85vh !important
    max-height: 85vh !important
    flex-direction: column !important
    overflow: hidden !important

  .dialog-card-fill
    display: flex !important
    flex-direction: column !important
    height: 100% !important

  .dialog-body-scroll
    flex: 1 !important
    overflow-y: auto !important
    padding: 16px

  .fill-dialog
    flex: 1 !important
    display: flex !important
    flex-direction: column !important

  .dialog-scroll
    height: 100vh
    max-height: 100vh !important
    overflow-y: auto !important
    overflow-x: hidden

  .custom-dialog-content-permissao
    height: 75vw !important
    max-height: 75vh !important
    overflow-y: auto !important
    overflow-x: hidden

  .dialog-container
    min-height: 70vh !important
    max-height: 70vh !important
    display: flex
    flex-direction: column

  .dialog-body
    flex: 1
    overflow-y: auto
    padding-bottom: 25px

  .dialog-footer-fixed
    position: sticky
    bottom: 0
    background: white
    padding: 12px
    z-index: 10
    border-top: 1px solid #ddd
    display: flex !important
    justify-content: center !important
    align-items: center !important

  .btn-unificado
    width: 150px !important
    max-width: 150px !important
    min-width: 150px !important
    border-radius: 10px !important

  .btn-unificado-salvar-excluir
    width: 80px !important
    max-width: 80px !important
    min-width: 80px !important
    border-radius: 10px !important

  #cadastrarUsuario
    border-radius: 10px !important

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemListaUsuario
    margin: -2rem 0 0 -1rem

  #buscaUsuario
    margin: -1.5rem 0 0 1rem

</style>
